import Vue from 'vue';

// base library
import {
  ConfigProvider,
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Icon,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Breadcrumb,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  PageHeader,
  Result,
  Statistic,
  Descriptions,
  Space,
  message,
  notification,
  Cascader,
  Pagination,
  Empty,
  Timeline,
} from 'ant-design-vue';
// import Viser from 'viser-vue';

// ext library
import VueCropper from 'vue-cropper';
import Dialog from '@/components/Dialog';
import MultiTab from '@/components/MultiTab';
import PageLoading from '@/components/PageLoading';
import PermissionHelper from '@/core/permission/permission';
import VueLazyload from 'vue-lazyload';
import './directives/action';

Vue.use(Empty);
Vue.use(Cascader);
Vue.use(ConfigProvider);
Vue.use(Layout);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Card);
Vue.use(Form);
Vue.use(Row);
Vue.use(Col);
Vue.use(Modal);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Badge);
Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(List);
Vue.use(Avatar);
Vue.use(Breadcrumb);
Vue.use(Steps);
Vue.use(Spin);
Vue.use(Menu);
Vue.use(Drawer);
Vue.use(Tooltip);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Skeleton);
Vue.use(Popconfirm);
Vue.use(PageHeader);
Vue.use(Result);
Vue.use(Statistic);
Vue.use(Descriptions);
Vue.use(Space);
Vue.use(Pagination);
Vue.use(Pagination);
Vue.use(Timeline);
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
// 配置 message 和 notification 的挂载容器，确保始终返回有效的容器
const safeGetContainer = () => {
  // 优先使用 document.body
  if (typeof document !== 'undefined' && document.body) {
    return document.body;
  }
  // 如果 document.body 不存在，尝试创建一个临时容器
  if (typeof document !== 'undefined') {
    let container = document.getElementById('message-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'message-container';
      // 确保添加到 documentElement (html)
      if (document.documentElement) {
        document.documentElement.appendChild(container);
      } else {
        // 最后的备选方案，直接添加到 body
        document.body = document.createElement('body');
        document.documentElement.appendChild(document.body);
        return document.body;
      }
    }
    return container;
  }
  // 不应该到达这里，但如果真的到达，返回一个空对象避免崩溃
  console.error('Unable to find or create a container for message/notification');
  return document.createElement('div');
};
message.config({
  getContainer: safeGetContainer,
});
notification.config({
  getContainer: safeGetContainer,
});
Vue.use(VueLazyload, {
  preLoad: 1.3, // 预加载高度比例
  error:
    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23FF4D4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"%3E%3Ccircle cx="12" cy="12" r="10"%3E%3C/circle%3E%3Cline x1="15" y1="9" x2="9" y2="15"%3E%3C/line%3E%3Cline x1="9" y1="9" x2="15" y2="15"%3E%3C/line%3E%3C/svg%3E',
  loading:
    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" style="margin:auto;display:block;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"%3E%3Ccircle cx="50" cy="50" r="32" stroke-width="8" stroke="%233498db" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round"%3E%3CanimateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.8s" keyTimes="0;1" values="0 50 50;360 50 50"%3E%3C/animateTransform%3E%3C/circle%3E%3C/svg%3E',
  attempt: 1, // 尝试加载次数
});

// Vue.use(Viser);
Vue.use(Dialog); // this.$dialog func
Vue.use(MultiTab);
Vue.use(PageLoading);
Vue.use(PermissionHelper);
Vue.use(VueCropper);

process.env.NODE_ENV !== 'production' && console.warn('[antd-pro] NOTICE: Antd use lazy-load.');
